import { render, staticRenderFns } from "./GalleryWriteItemAddLayout.vue?vue&type=template&id=33d049b8&scoped=true&"
import script from "./GalleryWriteItemAddLayout.vue?vue&type=script&lang=js&"
export * from "./GalleryWriteItemAddLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d049b8",
  null
  
)

export default component.exports